import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Grid, Button, Divider } from 'semantic-ui-react';
import moment from 'moment';
import 'rc-slider/assets/index.css';

// Components
import DividerForm from 'components/Forms/UI/DividerForm';
import SingleSelect from 'components/Forms/UI/Select';
import { DatePicker } from 'components/Forms/UI/DatePicker';
import { Column } from 'components/Layout';
import { Currency, Input } from 'components/Forms/UI/Input';

// Services and Utils
import { ROUTES } from 'shared/constants';
import istitutiOptions from 'shared/constants/istitutiOptions';
import {
  TIPO_GESTIONE_IMPRESA,
  TIPO_GESTIONE_IMPRESA_OPTIONS,
  TIPO_OPERAZIONE_IMPRESA_OPTIONS,
} from 'shared/constants/processoImprese';

class ImpresaBaseForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      istitutiOptions: [], // Istituto Options for form
    };
  }

  componentDidMount() {
    this.loadIstituti();
  }

  onChangeSelect = (name, value) => {
    this.props.setFieldValue(name, value.value);
  };

  /** Redirect to ProductList without saving */
  exitWithOutSaving = () => this.props.history.push(ROUTES.PROCESSO_IMPRESE);

  /** Load options of istituti */
  loadIstituti = () => {
    this.setState({ istitutiOptions });
  };

  render() {
    const { errors, setFieldTouched, setFieldValue, touched, values, isSubmitting, handleSubmit, isAperta } =
      this.props;

    const { istitutiOptions } = this.state;

    // Form is disabled when the pratica is not "aperta"
    const isDisabled = !isAperta;
    const isSegnalazioneCentroImpreseKiron =
      values.tipoGestione === TIPO_GESTIONE_IMPRESA.SEGNALAZIONE_CENTRO_IMPRESE_KIRON;

    const durataMassimaOptions = Array.from({ length: 8 }, (_, i) => {
      const years = (i + 1) * 5;
      return { value: years, label: `${years} anni` };
    });

    return (
      <div>
        <Form autoComplete="off" onSubmit={this.props.handleSubmit} loading={this.props.isSubmitting}>
          <Divider horizontal>dati pratica</Divider>
          <Grid>
            <Grid.Row columns={3}>
              <Column key="tipoGestione">
                <SingleSelect
                  label="Tipo gestione"
                  name="tipoGestione"
                  value={values.tipoGestione}
                  placeholder="Seleziona tipo gestione"
                  options={TIPO_GESTIONE_IMPRESA_OPTIONS}
                  onChange={this.onChangeSelect}
                  onBlur={(name, isTouched) => setFieldTouched(name, isTouched)}
                  error={errors.tipoGestione}
                  touched={touched.tipoGestione}
                  clearable
                  required
                  isDisabled={isDisabled}
                />
              </Column>
              <Column key="tipoProdotto">
                <SingleSelect
                  label="Tipo operazione"
                  name="tipoProdotto"
                  value={values.tipoProdotto}
                  placeholder="Seleziona tipo operazione"
                  options={TIPO_OPERAZIONE_IMPRESA_OPTIONS}
                  onChange={this.onChangeSelect}
                  onBlur={(name, isTouched) => setFieldTouched(name, isTouched)}
                  error={errors.tipoProdotto}
                  touched={touched.tipoProdotto}
                  clearable
                  required
                  isDisabled={isDisabled}
                />
              </Column>
              <Column key="scopoFinanziamento">
                <SingleSelect
                  label="Finalità"
                  name="scopoFinanziamento"
                  value={values.scopoFinanziamento}
                  placeholder="Seleziona la finalità"
                  options={[
                    {
                      value: 'Liquidità',
                      label: 'Liquidità',
                    },
                    {
                      value: 'Investimento da effettuare',
                      label: 'Investimento da effettuare',
                    },
                    {
                      value: 'Investimento effettuato',
                      label: 'Investimento effettuato',
                    },
                  ]}
                  onChange={this.onChangeSelect}
                  onBlur={(name, isTouched) => setFieldTouched(name, isTouched)}
                  error={errors.scopoFinanziamento}
                  touched={touched.scopoFinanziamento}
                  clearable
                  required
                  isDisabled={isDisabled}
                />
              </Column>
            </Grid.Row>

            <Grid.Row columns={2}>
              <Column key="istituto">
                <SingleSelect
                  label="Istituto"
                  name="istituto"
                  value={values.istituto}
                  placeholder="Seleziona istituto"
                  options={istitutiOptions}
                  onChange={this.onChangeSelect}
                  onBlur={(name, isTouched) => setFieldTouched(name, isTouched)}
                  error={errors.istituto}
                  touched={touched.istituto}
                  required={!isSegnalazioneCentroImpreseKiron}
                  clearable
                  isDisabled={isDisabled}
                />
              </Column>
              <Column key="numeroPraticaIstituto">
                <Input
                  {...this.props}
                  label="Numero pratica istituto"
                  name="numeroPraticaIstituto"
                  placeholder="Inserisci numero pratica istituto"
                  disabled={isDisabled}
                />
              </Column>
            </Grid.Row>

            <Grid.Row columns={2}>
              <Column key="importoRichiesto">
                <Currency
                  label="Capiale massimo da richiedere"
                  name="importoRichiesto"
                  {...this.props}
                  placeholder="Inserisci importo richiesto"
                  required={!isSegnalazioneCentroImpreseKiron}
                  disabled={isDisabled}
                />
              </Column>
              <Column key="durataMassima">
                <SingleSelect
                  label="Durata Massima"
                  name="durataMassima"
                  value={values.durataMassima}
                  placeholder="Seleziona la durata massima"
                  options={durataMassimaOptions}
                  onChange={this.onChangeSelect}
                  onBlur={(name, isTouched) => setFieldTouched(name, isTouched)}
                  error={errors.durataMassima}
                  touched={touched.durataMassima}
                  required={!isSegnalazioneCentroImpreseKiron}
                  clearable
                  isDisabled={isDisabled}
                />
              </Column>
            </Grid.Row>

            <Grid.Row columns={2}>
              <Column key="provvigione">
                <Currency
                  label="Importo provvigione"
                  name="importoProvvigione"
                  {...this.props}
                  placeholder="Inserisci provvigione"
                  disabled={isDisabled}
                />
              </Column>
              <Column key="garanziaSoggettiTerzi">
                <SingleSelect
                  label="Garanzie di soggetti terzi"
                  name="garanziaSoggettiTerzi"
                  value={values.garanziaSoggettiTerzi}
                  options={[
                    { value: true, label: 'Presenti' },
                    { value: false, label: 'Assenti' },
                  ]}
                  onChange={this.onChangeSelect}
                  onBlur={(name, isTouched) => setFieldTouched(name, isTouched)}
                  error={errors.garanziaSoggettiTerzi}
                  touched={touched.garanziaSoggettiTerzi}
                  clearable
                  isDisabled={isDisabled}
                />
              </Column>
            </Grid.Row>

            <Grid.Row columns={4}>
              <Column key="praticheInSofferenza">
                <SingleSelect
                  label="Pratiche in sofferenza"
                  name="praticheInSofferenza"
                  value={values.praticheInSofferenza}
                  options={[
                    { value: true, label: 'SI' },
                    { value: false, label: 'NO' },
                  ]}
                  onChange={this.onChangeSelect}
                  onBlur={(name, isTouched) => setFieldTouched(name, isTouched)}
                  error={errors.praticheInSofferenza}
                  touched={touched.praticheInSofferenza}
                  clearable
                  isDisabled={isDisabled}
                />
              </Column>
              <Column key="pregiudizievoli">
                <SingleSelect
                  label="Pregiudizievoli"
                  name="pregiudizievoli"
                  value={values.pregiudizievoli}
                  options={[
                    { value: true, label: 'SI' },
                    { value: false, label: 'NO' },
                  ]}
                  onChange={this.onChangeSelect}
                  onBlur={(name, isTouched) => setFieldTouched(name, isTouched)}
                  error={errors.pregiudizievoli}
                  touched={touched.pregiudizievoli}
                  clearable
                  isDisabled={isDisabled}
                />
              </Column>
              <Column key="pregiudizievoliDescription">
                <Input
                  {...this.props}
                  label="Descrizione pregiudizievoli"
                  name="pregiudizievoliDescription"
                  placeholder="Inserisci descrizione pregiudizievoli"
                  disabled={isDisabled}
                />
              </Column>
              <Column key="esclusivitaContrattoKiron">
                <SingleSelect
                  label="Esclusività contratto Kiron"
                  name="esclusivitaContrattoKiron"
                  value={values.esclusivitaContrattoKiron}
                  options={[
                    { value: true, label: 'SI' },
                    { value: false, label: 'NO' },
                  ]}
                  onChange={this.onChangeSelect}
                  onBlur={(name, isTouched) => setFieldTouched(name, isTouched)}
                  error={errors.esclusivitaContrattoKiron}
                  touched={touched.esclusivitaContrattoKiron}
                  clearable
                  isDisabled={isDisabled}
                />
              </Column>
            </Grid.Row>

            <Divider horizontal>dati generazione contratto</Divider>

            <Grid.Row columns={2}>
              <Column key="importoErogato">
                <Currency
                  {...this.props}
                  label="Importo erogato"
                  name="importoErogato"
                  placeholder="Inserisci importo erogato"
                  disabled={isDisabled}
                />
              </Column>
              <Column key="dataErogazione">
                <DatePicker
                  {...this.props}
                  setFieldTouched={setFieldTouched}
                  touched={touched}
                  value={values.dataErogazione}
                  onChange={setFieldValue}
                  name="dataErogazione"
                  label="Data erogazione"
                  openDirection="up"
                  startDate={moment()}
                  disabled={isDisabled}
                />
              </Column>
            </Grid.Row>

            <DividerForm />

            <Column width={8} textAlign="left">
              <Button.Group>
                <Button
                  onClick={this.exitWithOutSaving}
                  type="button"
                  icon="list"
                  labelPosition="right"
                  content="Torna all'elenco"
                  style={{ marginRight: '20px', width: '210px' }}
                />
              </Button.Group>
            </Column>
            <Column width={8} textAlign="right">
              {isAperta ? (
                <Button
                  loading={isSubmitting}
                  onClick={handleSubmit}
                  type="button"
                  icon="save"
                  labelPosition="right"
                  positive
                  disabled={isSubmitting}
                  content="Salva"
                  style={{ width: '200px' }}
                />
              ) : null}
            </Column>
          </Grid>
        </Form>
      </div>
    );
  }
}

ImpresaBaseForm.propTypes = {
  /** Used for manage history of the browser -> redirect */
  history: PropTypes.object,
  /** Used for manage form */
  isSubmitting: PropTypes.bool,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  setFieldTouched: PropTypes.func,
  handleSubmit: PropTypes.func,
  isAperta: PropTypes.bool,
};

export default ImpresaBaseForm;



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/ImpresaForm/Base/form.js